import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'cards.history.title',
        defaultMessage: 'Transactions',
    },
    errorText: {
        id: 'cards.history.error-text',
        defaultMessage: 'Something went wrong.',
    },
    retryBtn: {
        id: 'cards.history.retry-btn',
        defaultMessage: 'Refresh',
    },
    noMoreData: {
        id: 'cards.history.no-more-data',
        defaultMessage: 'No more transactions',
    },
})
